import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';

const McmPackageCrossroadsBasic: TenantPackageConfig<McmOrderContext> = {
  id: 'cr_basic',
  name: 'Crossroads Basic',
  hideSavings: true,
  performables: [
    McmPhotoConfig,
  ],
  eligible: ({ buyer, parent, metadata }) => Boolean(buyer.metadata.crossroads || parent?.crossroads) && (metadata.price ?? 0) < 200000,
  description: 'Up to 12 Photos'
};

export default McmPackageCrossroadsBasic;
